

























































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';
import { State, Getter, Action } from 'vuex-class';
import { Drag, Drop, DropList } from 'vue-easy-dnd';
import { Debounce } from '@/functions/debounce';

@Component({
  components: {
    ValidationProvider,
    Drag,
    DropList,
    Drop,
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
  },
})
export default class FormSearchProducts extends Mixins(Input) {
  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('collect/all') collects!: Collect[];

  @Action('product/index') indexProducts!: (payload?: { query?: IndexQuery<Product>; workspaceId: number }) => Promise<Product[]>;

  @Prop({ default: '' }) readonly value!: string | number;

  searchString: string = '';

  open: boolean = false;

  searchedProducts: Product[] = [];

  selectedProducts: Product[] = [];

  selectedProductIds: number[] = [];

  created() {
    this.initialProducts();
  }

  private reorder(event: { from: number; to: number; apply: ([]) => void }) {
    event.apply(this.selectedProducts);
    this.updateProducts();
  }

  private toggleProduct(product: Product) {
    const foundProduct = this.selectedProducts.find((sProduct) => sProduct.id === product.id);
    if (foundProduct === undefined) {
      this.selectedProducts.push(product);
      this.updateProducts();
      return;
    }
    this.selectedProducts.splice(this.selectedProducts.indexOf(foundProduct), 1);
    this.updateProducts();
  }

  private handleInitialSearch() {
    if (this.searchString === '' || this.open) {
      return;
    }
    this.open = true;
  }

  private initialProducts() {
    if (this.selectedProductIds.length === 0) {
      this.selectedProducts = [];
      return;
    }
    this.indexProducts({ query: { q: { or: { id: this.selectedProductIds } }, per_page: this.selectedProductIds.length }, workspaceId: this.workspace.id }).then((products: Product[]) => {
      const orderedProducts: Product[] = [];
      this.selectedProductIds.map((productId) => {
        const foundProduct = products.find((product) => product.id === productId);
        if (foundProduct === undefined) {
          return;
        }
        orderedProducts.push(foundProduct);
      });
      this.selectedProducts = orderedProducts;
    });
  }

  private removeProduct(list: Product[], item: Product) {
    const index = list.indexOf(item);
    list.splice(index, 1);
    this.updateProducts();
  }

  @Debounce(500)
  private searchProducts() {
    const query: IndexQuery<Product> = {
      per_page: 20,
    };
    if (this.searchString !== '') {
      query.q = {
        or: {
          name: [`like:*${this.searchString}*`, `match:${this.searchString}`],
        },
      };
    }

    this.indexProducts({ query, workspaceId: this.workspace.id }).then((products: Product[]) => {
      this.searchedProducts = products;
    });
  }

  @Emit('input')
  private updateProducts() {
    this.selectedProductIds = this.selectedProducts.map((product) => product.id ?? 0);
    return this.selectedProductIds;
  }

  @Watch('value', { immediate: true })
  private onValueChanged(val: number[]) {
    this.selectedProductIds = val;
  }

  @Watch('searchString')
  private onSearchChanged(val: string) {
    this.searchProducts();
  }

  @Watch('open')
  private onOpenChanged(val: boolean) {
    if (val) {
      if (this.searchedProducts.length === 0) {
        this.searchProducts();
      }
      // @ts-ignore
      this.$refs.input.$refs.input.focus();
    } else {
      this.searchString = '';
    }
  }
}
